import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import clientReducer from '../rdx/ClientSlice'
export default configureStore({
  reducer: {
    counter: counterReducer,
    client: clientReducer
  },
});
